export default "__VITE_ASSET__CVLAz0Eg__"